import ApiService from '../apiservice'

export default class CentralNotificacaoService extends ApiService {
  constructor() {
    super('/central-notificacao')
  }

	consultarNotificacoesUltimos(usuarioId) {
		return this.get(`/listar-ultimos-50/${usuarioId}`);
	}

	consultarPorDatas(usuarioId,dataInicio,dataFim) {
		return this.get(`/listar-datas?usuarioId=${usuarioId}&inicio=${dataInicio}&fim=${dataFim}`);
	}

	alterarSttaus(notificacaoId, status) {
		return this.put(`/altera-status/${notificacaoId}/${status}`);
	}

	excluirNotificacoes(notificacoes) {
		return this.post('/excluir-por-notificacoes',notificacoes);
	}

	marcarcomoLidos(notificacoes) {
		return this.post('/marcar-como-lidos',notificacoes); 
	}

	totalNotificacoesPorUsuario(usuario) {
		return this.get(`/contar-nao-lidas/${usuario}`);
	}
}